import { GlobalEmitter } from "../../common/utils/event";
import { SCORE_DATA } from "../../common/constants/attributes";
import { GlobalEvents } from "../../common/constants/event";

export const attachScoreListeners = () => {
  window[SCORE_DATA] = {};

  GlobalEmitter.on(GlobalEvents.INIT_SCORE, data => {
    window[SCORE_DATA][data.id].currentScore = data.currentScore;
  });

  GlobalEmitter.on(GlobalEvents.CHANGE_SCORE, data => {
    window[SCORE_DATA][data.id] = {
      currentScore: data.currentScore,
      totalScore: data.totalScore
    };
  });
};

export const sendScore = result => {
  if (typeof window.setActivityResults === "function") {
    window.setActivityResults(result);
  }
};
